/** Canonical entity keys for quick-add registry and options layer. */
export const REFERENCE_ENTITY_KEYS = Object.freeze({
  department: 'department',
  position: 'position',
  grade: 'grade',
  location: 'location',
  terminal: 'terminal',
  subDepartment: 'subDepartment',
  team: 'team',
});

/** Options list keys on useOrgReferenceOptions / profile options payload. */
export const REFERENCE_OPTIONS_KEYS = Object.freeze({
  department: 'departments',
  position: 'positions',
  grade: 'grades',
  location: 'locations',
  terminal: 'terminals',
  subDepartment: 'subDepartments',
  team: 'teams',
});

/** Max name lengths aligned with PHP validation. */
export const REFERENCE_NAME_MAX_LENGTH = Object.freeze({
  department: 120,
  position: 160,
  grade: 120,
  location: 160,
  terminal: 160,
  subDepartment: 160,
  team: 160,
});
